import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  total_open_positions: {
    name: 'Total number of open positions',
    order: 218
  }
};

export function OpenPositions({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.OPEN_POSITIONS,
    onChangeFund,
    schema: schema.OPEN_POSITIONS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.OPEN_POSITIONS?.field_names || [],
    tableName: 'OPEN_POSITIONS',
    columnLables,
    isMultiFunds,
    funds
  });
  return (
    <Table
      id="reporttables-open-positions-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
